var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHeader)?_c('div',[(_vm.isAccountSuspended && !_vm.isRemoteTerminalWindow)?_c('div',{staticClass:"warning"},[_vm._v(" Your account is suspended. Please add a valid payment method and credits to your account. ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }